import { createContext } from 'react';

const SchoolContext = createContext();

export default SchoolContext; 